<template>
    <div class="modal custom-modal fade show" id="minimumpremium" role="dialog" :class="{'modal-show':showModal}">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-head">
                    <div class="text-center">
                        <img src="@/assets/images/danger.png" width="100px" class="mt-3"/>
                    </div>
                </div>
                <div class="modal-body position-relative">
                    <div class="col-12 text-center mt-5">
                        <p class="h5">Proposal will be referred to underwriting for approval since computed OD premium is less than minimum premium</p>
                    </div>
                </div>
                    <div class="bgc-button-grp text-center">
                        <button type="button" class="bgc-btn-primary" @click="closeMinPremModal(true)" data-dismiss="modal">Cancel</button>
                        <button type="button" class="bgc-btn-secondary ml-3" data-dismiss="modal" @click="closeMinPremModal()">OK</button>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";

export default {
  name: "MinimumPremiumModal",
  props:["showModal"],
  components: {
    FloatLabel
  },
  setup(props, context) {
    function closeMinPremModal(fromCancel){
      context.parent.closeMinPremModal(fromCancel);
    }
    return{
        closeMinPremModal,
    } 
  },    
};
</script>
<style scoped>
.bgc-button-grp {
    padding-bottom: 46px;
}
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}
</style>